import { render } from "./MetadataIcons.vue?vue&type=template&id=1e51a6bc&scoped=true&ts=true"
import script from "./MetadataIcons.vue?vue&type=script&lang=ts"
export * from "./MetadataIcons.vue?vue&type=script&lang=ts"

import "./MetadataIcons.vue?vue&type=style&index=0&id=1e51a6bc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e51a6bc"]])

export default __exports__